<div class="header-group icon-left icon-m ui-icon-config">
    <h2>{{msg 'configuration'}}</h2>
</div>
<div class="inlineGroup fields">
    <field-checkbox label-key="trigger1" name="trigger1" col="12 12"></field-checkbox>
    <field-checkbox label-key="trigger2" name="trigger2" col="12 12"></field-checkbox>
    <field-checkbox label-key="trigger3" name="trigger3" col="12 12"></field-checkbox>
</div>